import { OUT_UNDER_INDEX_PERFORMERS, OUT_UNDER_PERFORMERS, OUT_UNDER_PERFORMERS_STREAM, } from "../../../interface/iOutUnderPerformers";
import { drivingMarketStreamingUpdate, } from "@domains/features/Markets/Equity/utils/streamingUpdate";
let initState = {
    data: [],
    indexData: [],
};
const outUnderPerformers = (state = initState, action) => {
    switch (action.type) {
        case OUT_UNDER_PERFORMERS:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case OUT_UNDER_INDEX_PERFORMERS:
            return Object.assign(Object.assign({}, state), { indexData: action.payload.data });
        case OUT_UNDER_PERFORMERS_STREAM:
            return Object.assign(Object.assign({}, state), { data: drivingMarketStreamingUpdate(state.data, action.payload.qouteStream), indexData: drivingMarketStreamingUpdate(state.indexData, action.payload.qouteStream) });
        default:
            return state;
    }
};
export default outUnderPerformers;
